import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from 'react-router-dom';
import Manutencao from '../Manutencao/Manutencao';
import Carregando from '../Carregando/Carregando';
import apiService from '../../api/home';

import Cabecalho from '../../components/Cabecalho';
import Menus from '../../components/Menus.js';
import PaginaItem from '../../components/PaginaItem.js';
import Rotape from '../../components/Rotape.js';
import WhatsApp from '../../components/botao_whatsapp.js';

import { ToastContainer } from 'react-toastify';


const Index = () => {

    const location = useLocation();
    const pathname = location.pathname;
    const navigate = useNavigate();
    const [DadosAPI, setDadosAPI] = useState(null);
    const [pageError, setPageError] = useState(false);


    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }




    useEffect(() => {

        const fetchData = async () => {
            try {
                var page = location.pathname;

                console.log("page", page)

                const result = await apiService.listar(page);
                console.log('Resultado', result)

                if (result.erro != "N") {
                    alert("COD 02 - Estamos com problemas! tente mais tarde.")
                    return false;
                }
                setDadosAPI(result.retorno);
                configPage(result.retorno);
                setFavicon(result.retorno.cabecalho[0].urllogo);

                // Move para o topo da página
                window.scrollTo(0, 0);
            } catch (error) {
                alert("COD 01 - Estamos com problemas! tente mais tarde.")
                setPageError(true)
                console.log(error)
            }
        };


        fetchData();
    }, [pathname]);


    const configPage = async (dados) => {

        //adicionar title da pagina
        if (dados && dados.pagina && dados.pagina.length > 0) {
            document.title = dados.pagina.titulo;
            return false
        }

        if (dados.cabecalho) {
            document.title = dados.cabecalho[0].ecommerce;
            return false
        }
    }

    const setFavicon = (url) => {
        let link = document.querySelector("link[rel~='icon']");

        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }

        link.href = url;
    };





    //Render

    if (pageError == true) {
        return (
            <>
                <Manutencao />
            </>
        )
    }

    if (DadosAPI == null) {
        return (
            <>
                <Carregando />
            </>
        )
    }



    //Construcao da pagina com base na API






    return (
        <>
            <Cabecalho DadosAPI={DadosAPI} />
            <ToastContainer />
            <WhatsApp DadosAPI={DadosAPI} />
            <Menus DadosAPI={DadosAPI} />
            <PaginaItem DadosAPI={DadosAPI} />
            <Rotape DadosAPI={DadosAPI} />
        </>
    );
};

export default Index;
